module.exports = __webpack_public_path__ + "img/Steor-Icon-09.bd179929.svg";